import { Component, OnInit, Output, EventEmitter, OnDestroy, ViewChild, Input, OnChanges, SimpleChanges, ElementRef, Injector, ChangeDetectorRef, } from '@angular/core';
import { MatDialogConfig } from '@angular/material/dialog';
import { MatTabGroup } from '@angular/material/tabs';
import { Observable, Subscription } from 'rxjs';
import { BaseComponent } from 'src/app/common/base/base.component';
import { Catalog, ActionPendingCatalog, } from 'src/app/common/enumerations/enumerations';
import { YesNoDialogComponent } from 'src/app/controls/yes-no-dialog/yes-no-dialog.component';
import { utils } from 'src/app/modules/libs/utils';
import { APLCategoryRoleCatalog } from 'src/app/components/apl/services/apl-category-role-catalog.model';
import { APLGroupRoleCatalog } from 'src/app/components/apl/services/apl-group-role-catalog.model';
import { APLGroupRoleRoleCatalog } from 'src/app/components/apl/services/apl-group-role-role-catalog.model';
import { CatalogModel } from 'src/app/components/catalogs/services/catalog-model';
import { ProcedureTraining } from 'src/app/components/procedure/models/procedure-training.model';
import { Procedure } from 'src/app/components/procedure/models/procedure.model';
import { Role } from 'src/app/components/catalogs/roles/services/role';
import { RolePrivilegePending, } from 'src/app/components/catalogs/roles/services/role-privilege';
import { RoleService } from 'src/app/components/catalogs/roles/services/role.service';
import { UserRole } from 'src/app/services/user-roles/user-role';
import { User } from 'src/app/components/catalogs/user-catalog/services/user';
import { CatalogService } from '../../catalog-service';
import { ProcedureTrainingRefresh } from 'src/app/components/procedure/store/procedure-training/procedure-training.action';
import { DisapprovalReasonComponent } from 'src/app/controls/disapproval-reason/disapproval-reason.component';
import { PendingApprovalsRefresh } from 'src/app/components/pending-approvals-v2/store/pending-approvals/pending-approvals.action';
import { RelatedLinkBase } from '../../navigation-links/link/related-link-base';
import { Router } from '@angular/router';
import { PendingCatalog } from '../../../../services/pending-approvals/pending-approval';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-role-details',
  templateUrl: './role-details.component.html',
  styleUrls: ['./role-details.component.scss'],
})
export class RoleDetailsComponent
  extends BaseComponent
  implements OnInit, OnDestroy, OnChanges {
  @Input() role?: Role | null;

  @Output() refreshRoles = new EventEmitter<any>();
  @Output() pending = new EventEmitter<boolean>();
  @Output() restoreRole = new EventEmitter<number>();
  @Output() roleSelected = new EventEmitter<Role | null>();

  @ViewChild('tabs') tabGroup!: MatTabGroup;
  @ViewChild('roleCode') roleCode!: ElementRef;

  displayedRole?: Role | null;

  roleCodeCtrl = new FormControl('', Validators.required);
  roleNameCtrl = new FormControl('', Validators.required);
  statusCtrl = new FormControl();
  performingWorkCtrl = new FormControl();
  trainingRoleCtrl = new FormControl();
  roleInformationCtrl = new FormControl();

  modifyingRolePrivileges!: boolean;

  selectedTabIndex = 0;

  userLogged!: User;
  catalog = Catalog;
  catalogModel!: CatalogModel;
  modifying = false;
  modifyingCatalogs: Catalog[] | null = [];
  adding = false;
  deleted = false;
  isPC!: boolean;
  isOnlyPTC? = false;
  isModifying!: boolean;

  showRoleModified!: boolean;
  roleModified!: boolean;
  invalidRoleName!: boolean;
  invalidRoleCode!: boolean;
  disabledStatus!: boolean;

  statusList: any = [
    { name: 'Active', id: 1 },
    { name: 'Inactive', id: 0 },
  ];

  procedureTraining$!: Observable<ProcedureTraining[]>;
  procedureTrainings!: ProcedureTraining[];
  dragEnabled = false;

  roles!: Role[];
  roles$!: Observable<Role[]>;
  rolesSubs!: Subscription;

  procedures!: Procedure[];
  procedures$!: Observable<Procedure[]>;
  proceduresSubs!: Subscription;

  rolePrivilegesPending!: RolePrivilegePending[];

  relatedLinks: RelatedLinkBase[] = [];

  constructor(
    protected override injector: Injector,
    public _service: RoleService,
    private _catalogService: CatalogService,
    private router: Router,
    private cdr: ChangeDetectorRef,
  ) {
    super(injector);
  }

  //#region Initialization
  ngOnChanges(changes: SimpleChanges): void {
    if (this.role) this.getDetails();
    else this.clear();
  }

  ngOnInit() {
    this.displayedRole = {} as Role;
    this.store.dispatch(new ProcedureTrainingRefresh());
    this.loadRoles();
    this.loadTrainings();
    this.loadProcedures();
    this.initializeForm();
    if (this.role) this.getDetails();
    else this.clear();
  }

  initializeForm() {
    this.formGroup = this.formBuilder.group({
      roleCodeCtrl: this.roleCodeCtrl,
      roleNameCtrl: this.roleNameCtrl,
      trainingRoleCtrl: this.trainingRoleCtrl,
      statusCtrl: this.statusCtrl,
      performingWorkCtrl: this.performingWorkCtrl,
      roleInformationCtrl: this.roleInformationCtrl,
    });
    this.formGroup.valueChanges.subscribe(() => {
      if (this.formGroup.dirty) this.setFormDirty();
      else this.setFormDirty(false);
    });
    this.trainingRoleCtrl.valueChanges.subscribe((value) => {
      if (this.displayedRole) {
        this.displayedRole.trainingRole = value;
      }
    });
    this.setFormDirty(false);
    this.formGroup.reset();
    this.formGroup.disable();
  }

  loadTrainings() {
    this.procedureTraining$ = this.store.select(
      (state) => state.ProcedureTraining.data,
    );
    this.procedureTraining$.subscribe((data: ProcedureTraining[]) => {
      if (data) {
        this.procedureTrainings = data.sort((a, b) =>
          utils.sort(
            a.procedureMaster?.procedure?.procedureNumber,
            b.procedureMaster?.procedure?.procedureNumber,
            true,
          ),
        );
      }
    });
  }

  loadProcedures() {
    this.procedures$ = this.store.select((state) => state.Procedures.data);
    this.proceduresSubs = this.procedures$.subscribe((data) => {
      if (data?.length) {
        this.procedures = data;
      }
    });
  }

  override ngOnDestroy(): void {
    this.rolesSubs?.unsubscribe();
  }

  loadRoles() {
    this.roles$ = this.store.select((state) => state.Roles.data);
    this.rolesSubs = this.roles$.subscribe((data) => {
      this.roles = data;
      if (this.role?.id) {
        this.role = this.roles.find((x) => x.id == this.role?.id);
        this.getDetails();
      }
    });
  }
  // #endregion

  //#region Details
  getDetails() {
    // --- UI/State resets ---
    this.resetDetailsState();

    // --- Normalize role + defaults ---
    this.displayedRole = this.utils.cloneDeep(this.role);
    if (!this.displayedRole) return;

    this.setValues();

    // --- Route by mode ---
    const id = this.displayedRole.id ?? 0;

    if (id < 0) {
      this.loadPendingRole(id);
    } else if (id === 0) {
      this.initNewRole();
    } else {
      this.loadExistingRole(id);
    }
  }

  /** ---------------- Helpers ---------------- */

  private resetDetailsState(): void {
    this.modifyingCatalogs = [];
    this.showRoleModified = false;
    this.roleModified = false;
    this.tabGroup.selectedIndex = 0;

    this.adding = false;
    this.modifying = false;
    this.dragEnabled = false;
    this.setFormDirty(false);
    this.formGroup.reset();
    this.formGroup.disable();
  }

  private parseRelatedLinks(value: any): any[] {
    return this.utils.JSONparse(value) ?? [];
  }

  /** Pending role (id < 0) */
  private loadPendingRole(roleId: number) {
  }

  /** New role (id === 0) */
  private initNewRole(): void {
    this.adding = true;
    this.modifying = false;
    this.dragEnabled = false;
    this.pending.emit(true);

    this.formGroup.enable();

    this.displayedRole!.status = 1;
    this.disabledStatus = true;

    this.relatedLinks = [];
  }

  /** Existing role (id > 0) */
  private loadExistingRole(roleId: number) {
    const result = this.displayedRole?.pendingRoles?.at(-1)?.modifyingResult;

    if (result?.isModifying && this.displayedRole) {
      this.applyModifyingState(result);
    }
  }

  private applyModifyingState(result: any): void {
    this.isModifying = !!result.isModifying;
    this.modifyingCatalogs = result.catalogs ?? [];

    this.showRoleModified = this.currentUser?.id === result.userID;

    // SA/PC-specific approval logic
    if ((this.isSA() || this.isPC) && this.currentUser?.id !== result.userID) {
      const rolePrivOnly = result.catalogs?.includes(Catalog.RolePrivileges);

      this._service._canApprove$?.next(this.hasPrivilege(
        this.privilegeEnum.RoleCatalogApprove,
      )
        ? !!result.isModifying
        : rolePrivOnly
          ? false
          : !!result.isModifying);

      this.showRoleModified = !!result.isModifying;
    }

    // Validate approvals (when not the modifier)
    if (this.currentUser?.id !== result.userID) {
      if (!result.catalogs?.includes(Catalog.RolePrivileges)) {
        this.ValidateCategoryManagerCanApprove(
          this.displayedRole!,
          result.isModifying,
        );
        this.ValidateGroupManagerCanApprove(
          this.displayedRole!,
          result.isModifying,
        );
        this.ValidateProcedureTrainingCoordinatorCanApprove(
          this.displayedRole!,
          result.isModifying,
        );
      }
    }

    // Auto-show modified banner for SA
    if ((this.isSA() || result.userID == this.currentUser?.id) && this.isModifying) {
      this.roleModified = true;
    }
    this.onShowRoleModified();

    // Common UI flags
    this.formGroup.disable();
    this.modifying = false;
    this.dragEnabled = false;
    this.adding = false;
    this.pending.emit(false);

    this.setActiveTab();
  }

  ValidateCategoryManagerCanApprove(data: Role, enable: boolean) {
    if (data?.aplGroupRole?.aplGroup?.aplGroupMaster?.aplCategoryMaster?.aplCategory?.aplCategoryManagers?.map(categoryManager => categoryManager?.user?.id).some(val => val === this.currentUser?.id)) {
      this.setApproveUnnapprove(enable);
    }
  }

  ValidateGroupManagerCanApprove(data: Role, enable: boolean) {
    if (data.aplGroupRole?.aplGroup?.aplGroupManagers?.map(groupManager => groupManager?.user?.id).some(userId => userId === this.currentUser?.id)) {
      this.setApproveUnnapprove(enable);
    }
  }

  ValidateProcedureTrainingCoordinatorCanApprove(data: Role, enable: boolean) {
    if (data.aplGroupRole?.aplGroup?.aplProcedureTrainingCoordinators?.map(ptc => ptc?.user?.id).some(userId => userId === this.currentUser?.id)) {
      this.setApproveUnnapprove(enable);
    }
  }

  setApproveUnnapprove(enable: boolean) {
    this._service._canApprove$?.next(enable);
    this.showRoleModified = enable;
  }

  // #endregion

  //#region Save Role
  saveRole(): void {
    const role = this.createRole();

    if (!role) {
      this.alert.error('Could not create the role data to save.');
      return;
    }

    const isNew = !this.displayedRole?.id;

    this.catalogModel.role = role;

    this._catalogService.SaveAsDraft(this.catalogModel, Catalog.Roles).subscribe({
      next: () => this.handleRoleSaved(role, isNew),
      error: () => this.alert.error('An error occurred while saving the role.'),
    });
  }

  private handleRoleSaved(role: Role, isNew: boolean): void {
    const message = isNew
      ? 'The New Role Has Been Sent To Approve Successfully!!'
      : 'The Role Modification Has Been Sent To Approve Successfully!!';

    this.alert.success(message);
    this.setFormDirty(false);
    this.roleSelected.emit(role);
  }

  restoreInfo() {
    if (this.displayedRole) {
      this.getDetails();
      this.restoreRole.emit(this.displayedRole.id);
    }
  }

  approve() {
    if (this.displayedRole?.id)
      this._catalogService
        .Approve(this.displayedRole.id, Catalog.Roles)
        .subscribe(
          () => {
            this.alert.success('Role Approved Successfully!!');
            this.refreshRoles.emit();
          },
          (error) => {
            if (error?.status === 0) {
              this.alert.error('Unable to reach the server. Please check your connection and try again.');
            } else {
              this.alert.error(error?.error ?? 'An error occurred while approving the role.');
            }
          }
        );
  }

  disapprove(disapprovalReason: string) {
    if (this.displayedRole?.id)
      this._catalogService
        .Unapprove(this.displayedRole.id, Catalog.Roles, disapprovalReason)
        .subscribe(
          () => {
            this.alert.success('Role Disapproved Successfully!!');
            this.refreshRoles.emit();
          },
          (error) => {
            if (error?.status === 0) {
              this.alert.error('Unable to reach the server. Please check your connection and try again.');
            } else {
              this.alert.error(error?.error ?? 'An error occurred while disapproving the role.');
            }
          }
        );
  }

  async deleteRole() {
    if (!this.canDeleteRole()) {
      this.alert.error(
        'The role must be approved as inactive and have no role users before it can be deleted.',
      );
      return;
    }

    if (await this.canDeactivate())
      this.dialog
        .open(YesNoDialogComponent, {
          minWidth: '400px',
          data: {
            message: this.getMessage(
              'Delete_Role_Question',
            ).description.replace('{role}', this.displayedRole?.name ?? '') +
              '<br/><br/>This will send the role deletion for approval.',
            icon: 'stop',
          },
        })
        .afterClosed()
        .toPromise()
        .then((res) => {
          if (res) {
            this.catalogModel.role = this.createRole();
            this.catalogModel.action = ActionPendingCatalog.Delete;
            this._catalogService
              .SaveAsDraft(this.catalogModel, Catalog.Roles)
              .toPromise()
              .then((pendingRoleId) => {
                this.markRoleDeletePending(pendingRoleId);
                this.alert.success(
                  'The Role Deletion Has Been Sent To Approve Successfully!!',
                );
                this.refreshRoles.emit();
              })
              .catch((error) => {
                this.alert.error(
                  error?.error ??
                  'An error occurred while sending the role deletion for approval.',
                );
              });
          }
        });
  }

  private markRoleDeletePending(pendingRoleId?: number) {
    if (!this.role?.id) return;

    this.role.pendingRoles = [
      {
        id: pendingRoleId,
        roleId: this.role.id,
        roleName: this.role.name,
        roleCode: this.role.code,
        action: ActionPendingCatalog.Delete,
        createdBy: this.currentUser?.id,
        createdByUser: this.currentUser,
        createdOn: new Date(),
        show: true,
        roleData: this.utils.JSONstringify(this.catalogModel.role),
        modifyingResult: {
          isModifying: true,
          userID: this.currentUser?.id,
          catalogs: [Catalog.Roles],
        },
      } as any,
    ];
  }

  canDeleteRole(): boolean {
    return !!(
      this.role?.id &&
      this.role.id > 0 &&
      this.role.status === 0 &&
      !this.role.pendingRoles?.length &&
      (this.role.userRole?.length ?? 0) === 0 &&
      !this.isOnlyPTC &&
      this.canDeleteRoleByAssignment()
    );
  }

  private canDeleteRoleByAssignment(): boolean {
    return (
      this.hasPrivilege(this.privilegeEnum.RoleCatalogChanges) ||
      this.isRoleGroupManager() ||
      this.isRoleCategoryManager()
    );
  }

  private isRoleGroupManager(): boolean {
    return !!this.role?.aplGroupRole?.aplGroup?.aplGroupManagers?.some(
      (manager) => manager?.userID === this.currentUser?.id,
    );
  }

  private isRoleCategoryManager(): boolean {
    return !!this.role?.aplGroupRole?.aplGroup?.aplGroupMaster?.aplCategoryMaster?.aplCategory?.aplCategoryManagers?.some(
      (manager) => manager?.userID === this.currentUser?.id,
    );
  }

  openAddDisapprovalDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = '';
    const dialogRef = this.dialog.open(
      DisapprovalReasonComponent,
      dialogConfig,
    );
    dialogRef.afterClosed().subscribe((data) => {
      if (data != undefined) {
        this.disapprove(data);
      }
    });
  }

  cancelPendingChanges() {
    const dialogRef = this.dialog.open(YesNoDialogComponent, {
      minWidth: '400px',
      data: {
        message: 'Are you sure to cancel your pending changes?',
        icon: 'stop',
      },
    });
    dialogRef.afterClosed().subscribe((data) => {
      if (data) {
        if (this.displayedRole?.id)
          this._catalogService.Unapprove(this.displayedRole.id, Catalog.Roles, 'Canceled by Requester').subscribe(() => {
            this.alert.success('Role Changes Cancelled Successfully!!');
            this.refreshRoles.emit();
          });
      }
    });
  }

  /**
   * Opens the pending role draft for editing without allowing approved values to replace it.
   * Keeps the modification comparison active until the edit is saved or canceled.
   */
  modifyRole() {
    this.formGroup.enable();
    this.modifying = true;
    // Read pending metadata from the canonical role because the displayed role may show approved values.
    const result = this.role?.pendingRoles?.at(-1)?.modifyingResult;
    this.roleModified = (result?.userID == this.currentUser?.id);
    this.onShowRoleModified()
    this.pending.emit(this.modifying || this.adding);
    if (!this.isOnlyPTC) {
      this.dragEnabled = true;
    }
  }

  modifyRolePrivileges() {
    this.modifyingRolePrivileges = true;
  }

  endModifyRolePrivileges() {
    this.modifyingRolePrivileges = false;
  }

  aplCategoryIDChanged(e: any) {
    if (
      this.displayedRole?.aplGroupRole?.aplGroup?.aplGroupMaster
        ?.aplCategoryMaster?.aplCategory?.id
    ) {
      this.displayedRole.aplGroupRole.aplGroup.aplGroupMaster.aplCategoryMaster.aplCategory.id =
        e;
      this.setFormDirty();
    }
  }

  aplGroupIDChanged(e: any) {
    if (this.displayedRole?.aplGroupRole)
      this.displayedRole.aplGroupRole.aplGroup.id = e;
    this.setFormDirty();
  }

  createRole(): Role | undefined {
    const roleUsersToSend = (this.displayedRole?.userRole ?? [])
      .filter((userRole) => !userRole.pendingDelete)
      .map((ur) => { const u = { ...ur }; delete u.pendingDelete; return u; });
    const trainingsToSend = utils.cloneDeep(this.displayedRole?.procedureTrainings ?? []);
    trainingsToSend.forEach((t) => {
      if (t.procedureMaster) t.procedureMaster.procedure = undefined;
      t.role = undefined;
    });
    if (this.displayedRole) {
      const role: Role = {
        id: this.displayedRole.id,
        code: this.roleCodeCtrl.value,
        name: this.roleNameCtrl.value,
        status: this.statusCtrl.value,
        information: this.roleInformationCtrl.value,
        performingWork: this.performingWorkCtrl.value,
        trainingRole: this.trainingRoleCtrl.value,
        roleALSPCSupervisors: this.displayedRole.roleALSPCSupervisors,
        roleALSPCDesignees: this.displayedRole.roleALSPCDesignees,

        userRole:
          this.statusCtrl.value == 0
            ? []
            : roleUsersToSend,

        procedureTrainings: trainingsToSend ?? [],
        rolePrivilegesPending: this.rolePrivilegesPending,
        relatedLinks: this.utils.JSONstringify(this.relatedLinks),
      };
      return role;
    } else return undefined;
  }

  clear() {
    this.setFormDirty(false);
    this.formGroup?.reset();
    this.formGroup?.disable();
    this.catalogModel = new CatalogModel();

    this.adding = false;
    this.modifying = false;
    this.dragEnabled = false;
    this.pending.emit(this.modifying || this.adding);
    this.showRoleModified = false;
    this.roleModified = false;
    this.isModifying = false;
    this.invalidRoleCode = false;
    this.invalidRoleName = false;
    this.disabledStatus = false;
    this.deleted = false;
    this.relatedLinks = [];
  }

  reset() {
    this.dragEnabled = false;

    this.refreshRoles.emit('reset');
    this.clear();

    this.restoreInfo();
    this.store.dispatch(new PendingApprovalsRefresh());
  }

  async discardChanges() {
    if (await this.canDeactivate()) {
      if (!this.role?.id) {
        this.formGroup.reset();
        this.formGroup.disable();
        this.role = null;
        this.roleSelected.emit(this.role);
      } else {
        this.getDetails();
        this.setValues();
      }
    }
  }

  onShowRoleModified() {
    if (this.roleModified) {
      if (this.isModifying && this.displayedRole?.id) {
        const pendingRole = this.role?.pendingRoles?.at(-1);
        const roleData = this.utils.JSONparse(pendingRole?.roleData);

        setTimeout(() => {
          this.displayedRole = this.utils.cloneDeep(roleData) as Role;
          this.relatedLinks = this.utils.JSONparse(
            this.displayedRole.relatedLinks,
          );
          this.setValues();
          if (this.tabGroup.selectedIndex == 0) {
            this.setActiveTab();
          }
          this.cdr.markForCheck();
        });
      }
    } else {
      setTimeout(() => {
        this.displayedRole = this.utils.cloneDeep(this.role);
        if (this.displayedRole) {
          this.deleted = false;
          this.setValues();
        }
        this.cdr.markForCheck();
      });
    }
  }

  /**
   * Populates form controls and data sources with values from the displayed role.
   * Asynchronously resolves created/updated user references after 100ms delay.
   */
  private setValues(): void {
    if (this.displayedRole) {
      this.roleCodeCtrl.setValue(this.displayedRole?.code ?? null);
      this.roleNameCtrl.setValue(this.displayedRole?.name ?? null);
      this.statusCtrl.setValue(this.displayedRole?.status);
      this.performingWorkCtrl.setValue(this.displayedRole?.performingWork);
      this.trainingRoleCtrl.setValue(this.displayedRole?.trainingRole);
      this.roleInformationCtrl.setValue(this.displayedRole?.information);

      this.displayedRole.aplGroupRole =
        this.displayedRole.aplGroupRole ??
        this.role?.aplGroupRole ??
        new APLGroupRoleRoleCatalog();

      this.relatedLinks = this.utils.JSONparse(this.displayedRole.relatedLinks);

      this.displayedRole.rolePrivileges = this.role?.rolePrivileges;

      setTimeout(() => {
        if (this.displayedRole) {
          this.displayedRole.createdByUser = this.users.find(
            (x) => x.id == this.displayedRole?.createdBy,
          );
          this.displayedRole.updatedByUser = this.users.find(
            (x) => x.id == this.displayedRole?.updatedBy,
          );
          this.cdr.markForCheck();
        }
      }, 100);
    }
  }

  setActiveTab() {
    if (this.modifyingCatalogs?.length) {
      switch (this.modifyingCatalogs[0]) {
        case Catalog.Roles:
          this.tabGroup.selectedIndex = 0;
          break;
        case Catalog.Users:
          this.tabGroup.selectedIndex = 1;
          break;
        case Catalog.RolePrivileges:
          this.tabGroup.selectedIndex = 2;
          break;
        case Catalog.Trainings:
          this.tabGroup.selectedIndex = 3;
          break;
      }
    }
  }

  changeStatusRole(data: any) {
    if (data == 0) {
      if ((this.displayedRole?.userRole?.filter((u) => !u.pendingDelete).length ?? 0) > 0)
        this.alert.message(this.getMessage('Warning_Inactive_Role'));
      this.displayedRole!.userRole = [];
    }
    this.setFormDirty();
  }

  keydown(event: KeyboardEvent) {
    if (event.keyCode === 13) {
      event.preventDefault();
      if (this.displayedRole?.information) {
        this.displayedRole.information += '\n';
      } else {
        if (this.displayedRole) {
          this.displayedRole.information = '';
          this.displayedRole.information += '\n';
        }
      }
    }
  }

  // blur() {
  //     this.displayedRole.information = this.displayedRole.information.substr(0, this.maxlength);
  // }

  getGroupManagers(group?: APLGroupRoleCatalog): string | undefined {
    return group?.aplGroupManagers
      ?.map((groupManager) => groupManager?.user?.name)
      ?.join(', ');
  }

  getCategoryManagers(category?: APLCategoryRoleCatalog): string | undefined {
    return category?.aplCategoryManagers
      ?.map((categoryManager) => categoryManager?.user?.name)
      ?.join(', ');
  }

  getProcedureCenterCoordinators(
    group?: APLGroupRoleCatalog,
  ): string | undefined {
    return group?.aplProcedureTrainingCoordinators
      ?.map((ptc) => ptc?.user?.name)
      ?.join(', ');
  }

  setRolePrivilegesPending(e: RolePrivilegePending[]) {
    this.rolePrivilegesPending = e;
    this.setFormDirty();
  }

  roleChanged(e: any) {
    const val = (e.target.value as string).toLowerCase().trim();
    if (this.displayedRole) {
      if (this.roles.map((r) => r.code?.toLowerCase()).includes(val)) {
        this.roleCodeCtrl.setErrors({ duplicate: true });
      }
      if (!val) {
        this.roleCodeCtrl.setErrors({ required: true });
      }
      this.displayedRole.code = val.toUpperCase();
      this.setFormDirty();
    }
  }

  roleNameChanged(e: any) {
    const val = (e.target.value as string).toLowerCase().trim();
    if (this.displayedRole) {
      if (this.roles.map((r) => r.name?.toLowerCase()).includes(val)) {
        this.roleNameCtrl.setErrors({ duplicate: true });
      }
      if (!val) {
        this.roleNameCtrl.setErrors({ required: true });
      }
      this.displayedRole.name = val.toUpperCase();
      this.setFormDirty();
    }
  }

  relatedLinksChanged(relatedLinks: RelatedLinkBase[]) {
    this.relatedLinks = relatedLinks;
    this.setFormDirty();
  }

  checkDiffWPCLinks() {
    if (this.showRoleModified)
      return (
        (this.displayedRole?.relatedLinks ?? '[]') !=
        (this.role?.relatedLinks ?? '[]')
      );
    return false;
  }

  activateRole() {
    if (this.displayedRole)
      this.dialogService
        .ConfirmationDialog(
          'Re-Activate Role',
          `<b>${this.displayedRole.name}</b>`,
          'question',
        )
        .toPromise()
        .then((res) => {
          if (res) {
            this.statusCtrl.setValue(1);
            this.saveRole();
          }
        });
  }

  navigateToCatalog(id: number) {
    const route = '/users';
    const dummyCatalog = { id: id } as PendingCatalog;
    this._catalogService.pendingCatalog = dummyCatalog;
    this.router.navigate([route]);
  }

  isUserModified(e: any) {
    if (!this.showRoleModified) return false;
    return !this.role?.userRole?.find(
      (ur) => ur.userID === e.userID && ur.order === e.order,
    );
  }

  onRoleUsersChange(users: UserRole[]) {
    if (this.displayedRole) {
      this.displayedRole.userRole = users;
    }
  }

  roleHasPendingChanges(): boolean {
    return !!(this.role?.pendingRoles?.length);
  }

  onRoleTrainingsChange(trainings: any[]) {
    if (this.displayedRole) {
      this.displayedRole.procedureTrainings = trainings as any;
    }
  }

  isRolePendingDelete(): boolean {
    return this.role?.pendingRoles?.at(-1)?.action === ActionPendingCatalog.Delete;
  }
}
